import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const API_PREFIX = `${BASE_URL}/extract-claims-logs`;

export const listExtractClaimsLogs = (params) =>
  axios.get(`${API_PREFIX}`, {
    params,
    headers: getAuthHeaders(),
  });

export const getExtractClaimsLogsFilterOptions = () =>
  axios.get(`${API_PREFIX}/filter-options`, {
    headers: getAuthHeaders(),
  });

export const getExtractClaimsLogDetail = (id) =>
  axios.get(`${API_PREFIX}/${encodeURIComponent(id)}`, {
    headers: getAuthHeaders(),
  });

export const exportExtractClaimsLogs = (params) =>
  axios.get(`${API_PREFIX}/export`, {
    params,
    headers: getAuthHeaders(),
    responseType: "blob",
  });

